import type { DesignVersion } from '@fluentui-copilot/react-provider';
import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';
import type { ReferenceListState } from '../ReferenceList';

export type ReferenceSlots = {
  /** The root of the component that renders the reference as either a button or an anchor element. */
  root: NonNullable<Slot<'button', 'a'>>;

  /** The number of the citation this reference corresponds to. */
  citation?: Slot<'span'>;

  /** A divider that visually separates the citation from the content of the reference. */
  divider?: Slot<'span'>;

  /** A space containing the content of the reference, which goes into an ellipsis if it overflows. */
  content?: Slot<'span'>;

  /** A space within the content slot where a graphic such as an icon or an image can be displayed before the rest of the content. */
  graphic?: Slot<'span'>;
};

export type ReferenceProps = ComponentProps<Partial<ReferenceSlots>> & DesignVersion & {};

export type ReferenceState = ComponentState<ReferenceSlots> &
  Required<Pick<ReferenceProps, 'id' | 'designVersion'>> &
  Pick<ReferenceListState, 'shouldUseOverflow'>;
